<div>
<div class="back-container">
  <div class="main-container" id="body">
    <header class="header">
      <div>
        <div class="container prt">
          <nav class="navbar navbar-dark sticky-top access">
            <div>
             <ul class="menu">
               <li *ngIf="(isLogin |async)">
                 <a href="#">
                    <h5>{{userName | async}}</h5>
                 </a>
                 <a href="#" routerLink="/tracking/manager" routerLinkActive="active" *ngIf="(isSuperAdmin |async)"> <h5>ADMINISTRAR</h5></a>
               </li>
               <li  *ngIf="!(isLogin |async)">
                 <a href="#"  data-toggle="modal" data-target="#modalLogIn" data-placement="login">Ingresar al sistema</a>
               </li>
               <li  *ngIf="(isLogin |async)">
                <a href="#" (click)="logOut()">Salir del Sistema</a>
              </li>
             </ul> 
            </div>
          </nav>
        </div>
      </div>  
      <nav class="navbar navbar-expand-lg navbar-dark sticky-top nav-head header">
      <div class="container">
        <a class="navbar-brand" href="/">
          <span class="text-left tit">FENIX</span>
          <span class="tit">Transport</span>
        </a>
      </div>
    </nav>
    </header>
    <div class="line background-accent"></div>
    
    
    <div class="hx">
      <flash-messages></flash-messages>
      <router-outlet class="container"></router-outlet>
    </div>
  </div>
  <footer class="font-small background-accent pt-3">
    <div class="footer-copyright text-center py-2">©
      <span id="Lima_z14e"></span>
      <span> Perú</span>
    </div>
  </footer>
</div>
<div class="shadow"></div>
</div>

<div class="modal" tabindex="-1" role="dialog" id="modalLogIn">
  <div class="modal-dialog" role="document">
    <div class="modal-content ">
        <div class="modal-header">
          <h5 class="modal-title" id="titleDeleteSocial"><i>Ingresar al Sistema</i></h5>
          <button class="close" type="button" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body m-3" align="center">
          <img src="favicon.ico" width="30%">
          <div class="p-3">
            <div class="container">
              <form method="POST" #fRecommend="ngForm" [formGroup]="sendForm" (submit)="onSignInSubmit($event)"
              class = "mx-auto my-2" enctype="application / x-www-form-urlencoded"  style="width: 400px">
                <div class="card mt-3">
                  <div class="card-body table">
                    <div class="form-group">
                      <label for="user">Usuario:</label>
                      <input type="text" [ngClass]="{ 'is-invalid': fRecommend.submitted && sendForm.controls.user.errors }" class="form-control" placeholder="user.sss@gmail.com" formControlName="user" name="user">
                      <span></span>
                    </div>
                    <div class="form-group">
                        <label for="password">Contraseña:</label>
                        <input type="password" [ngClass]="{ 'is-invalid': fRecommend.submitted && sendForm.controls.password.errors }" class="form-control" placeholder="********"  formControlName="password" name="password">
                      </div>
                  </div>
                  <div *ngIf="fRecommend.submitted && errors">
                      <p  class="errors">
                          {{errors}}
                      </p>
                  </div>
                  <div class="card-footer" align="center">
                       <input type="reset" value="limpiar" class="btn btn-secondary m-1">
                       <input type="submit" value="ingresar" class="btn btn-secondary m-1">
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
    </div>
  </div>
</div>